import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { DrugExpiryDate } from '../DrugExpiryDate';

type StyledRootProps = {
  isDorimSpecialOffer?: boolean;
};

const StyledRoot = styled(Stack, {
  shouldForwardProp: prop => prop !== 'isDorimSpecialOffer',
})<StyledRootProps>(({ theme, isDorimSpecialOffer }) => ({
  alignItems: 'center',
  height: 22,
  borderRadius: theme.shape.borderRadiusHalf,
  border: theme.shape.divider,
  borderColor: isDorimSpecialOffer ? theme.palette.primary.main : theme.palette.error.main,
  paddingRight: theme.spacing(0.5),
  overflow: 'hidden',

  '> .count': {
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    color: theme.palette.common.white,
    backgroundColor: isDorimSpecialOffer ? theme.palette.primary.main : theme.palette.error.main,
  },

  '> .drug': {
    display: 'flex',
    alignItems: 'center',
  },
}));

export type DrugSpecialOfferItemProps = StyledRootProps & {
  count: number;
  drugName: string;
  expiryDate?: string;
  makerName?: string;
  makerCountryName?: string;
};

export const DrugSpecialOfferItem = (props: DrugSpecialOfferItemProps) => {
  const { count, drugName, expiryDate, makerName, makerCountryName, isDorimSpecialOffer } = props;

  const makerFullName = makerName ? ` ${makerName} ${makerCountryName ? ` (${makerCountryName})` : ''}` : '';

  return (
    <StyledRoot isDorimSpecialOffer={isDorimSpecialOffer} direction="row" spacing={0.5}>
      <Typography noWrap component="p" variant="Body/small" className="count">
        {count} ×
      </Typography>
      <Typography noWrap component="p" variant="Body/small" className="drug">
        {drugName}
        {makerFullName}
      </Typography>
      {expiryDate && <DrugExpiryDate type="colorful" variant="Body/small" value={expiryDate} />}
    </StyledRoot>
  );
};
